var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"foo","position":"bottom center","max":4}}),_c('MainLayout',[_c('FadeTransition',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }